import { Loading } from '@linktivity/link-ui';

import styles from './pageLoading.module.css';

const PageLoading = () => (
  <div className={styles.loading}>
    <Loading />
  </div>
);

export default PageLoading;
